import { forwardRef } from 'react'
import { FormProps, InputBaseProps } from './types'
import FormElement, {
    FormElementProps,
    withInputClass,
} from './wrappers/FormElement'

export type TextProps = Omit<InputBaseProps, 'type'> & FormElementProps

export const TextInputBase = forwardRef<HTMLInputElement, TextProps>(
    ({ name, error, label, className, ...props }, ref) => (
        <input
            name={name}
            ref={ref}
            type="password"
            className={withInputClass(className)}
            {...props}
        />
    ),
)

export const TextInput = forwardRef<HTMLInputElement, TextProps>(
    ({ name, error, label, className, ...props }, ref) => (
        <FormElement name={name} error={error} label={label}>
            <TextInputBase
                name={name}
                ref={ref}
                className={withInputClass(className)}
                {...props}
            />
        </FormElement>
    ),
)

export const Password = <FormValues,>({
    register,
    name,
    ...props
}: FormProps<FormValues, TextProps>) => (
    <TextInput {...register(name)} name={name} {...props} />
)
